// extracted by mini-css-extract-plugin
export var avatarContainer = "_dx-0";
export var avatarTypingWave = "_dx-i";
export var gray = "_dx-f";
export var green = "_dx-c";
export var icon = "_dx-9";
export var image = "_dx-1";
export var lg = "_dx-6";
export var md = "_dx-5";
export var presenceDot = "_dx-b";
export var red = "_dx-d";
export var sm = "_dx-4";
export var status = "_dx-a";
export var typingDot = "_dx-h";
export var typingPill = "_dx-g";
export var xl = "_dx-7";
export var xs = "_dx-3";
export var xxl = "_dx-8";
export var xxs = "_dx-2";
export var yellow = "_dx-e";